var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.711,
    viewBox: "0 0 16 13.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-eye-off",
    "data-name": "Icon ionic-md-eye-off",
    d: "M10.252,7.385a3.627,3.627,0,0,1,3.638,3.61,3.472,3.472,0,0,1-.261,1.321l2.125,2.107a8.536,8.536,0,0,0,2.5-3.428,8.617,8.617,0,0,0-10.9-4.91L8.92,7.646A3.6,3.6,0,0,1,10.252,7.385ZM2.978,5.418l1.66,1.646.336.332a8.5,8.5,0,0,0-2.724,3.6A8.629,8.629,0,0,0,13.437,15.8l.307.3,2.132,2.107.925-.918L3.9,4.5ZM7,9.406l1.128,1.118a2.045,2.045,0,0,0-.057.468,2.171,2.171,0,0,0,2.182,2.164,2.052,2.052,0,0,0,.471-.057l1.128,1.118a3.619,3.619,0,0,1-5.238-3.228A3.567,3.567,0,0,1,7,9.406Zm3.135-.561,2.292,2.274.014-.114a2.171,2.171,0,0,0-2.182-2.164Z",
    transform: "translate(-2.25 -4.5)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.8142d2023697ffb630b75db94372c799.svg";
export { ForwardRef as ReactComponent };